import { Languages } from '@livv/models';
import { SxProps, Typography } from '@mui/material';
import useTranslation from 'next-translate/useTranslation';
import { FC } from 'react';
import { sxs } from '@utils/mui/sx';
import { displayThousands } from '@utils/number';

const MIN_NB_HITS_FOR_APPROX_CHAR = 1000;

interface ResultsCountProps {
    nbResults: number;
    sx?: SxProps;
}

const ResultsCount: FC<ResultsCountProps> = ({ nbResults, sx = {} }) => {
    const { t, lang } = useTranslation('search');

    return (
        <Typography data-test-id="results-count" mr="auto" sx={sxs([{ color: 'grey.400' }, sx])}>
            {nbResults
                ? `${nbResults > MIN_NB_HITS_FOR_APPROX_CHAR ? '~' : ''}${displayThousands(
                      nbResults,
                      lang as Languages,
                  )} ${t('results.nbHits', {
                      count: nbResults,
                  })}`
                : t('results.noHit')}
        </Typography>
    );
};

export default ResultsCount;
